import React from 'react'

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import Banner2 from "../components/Banner2";
import Social from '../components/Social';
import ContactForm from '../components/ContactForm';

const Contacto = () => {
  return (
    <div>
      <Navbar />
      <Banner2 heading="CONTACTO" text="¿Tienes alguna duda? ¿Alguna propuesta?" />
      <ContactForm/>
      <Social/>
      <Footer />
    </div>
  )
}

export default Contacto